import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { AccountService } from '@app/core/services/Common/account.service';
import { AccountEndpoint } from '@app/core/endpoints/account-endpoint.service';

@Component({
  selector: 'sa-login-disclaimer',
  templateUrl: './login-disclaimer.component.html',
  styleUrls: ['./login-disclaimer.component.css'],
  providers: [AccountService, AccountEndpoint]
})
export class LoginDisclaimerComponent implements OnInit {
  constructor(public bsModalRef: BsModalRef, private router: Router, private accountService: AccountService) { }

  ngOnInit() {
  }

  onDisagree() {
    this.router.navigate(["/authentication/logout"], { state: { local: true } });
    this.bsModalRef.hide();
  }

  onAgree() {
    this.bsModalRef.hide();
    this.accountService.amendUserConsent().subscribe(res => {
      console.log(res);
    });
  }

}
